// withSort
export const SORT = 'sort';

export const SORT_TYPE_ALPHABETIC = 'alphabetic';

export const SORT_MODE_ASC = 'asc';
export const SORT_MODE_DESC = 'desc';
